import { render, staticRenderFns } from "./FxStatistics.vue?vue&type=template&id=2dcf9d17&"
import script from "./FxStatistics.vue?vue&type=script&lang=js&"
export * from "./FxStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports